import * as React from 'react';
import { ActionPointInfo, Controller, CustomArgs, IActionPointInfo, Toolbar, UIConfig, WorkbenchUIConfig } from '@tencent/workbench';
import { EffectFeature } from './effect-feature';
import { TOOLBAR_ITEMS, config } from './config';
import { wrapIdForBig, wrapIdForCommon, wrapIdForPic, wrapIdForText, wrapIdForTextTab } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class EffectController {
    constructor(private readonly feature: EffectFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForText(config.id), 'dropdownContent')
    @Toolbar(wrapIdForPic(config.id), 'dropdownContent')
    @Toolbar(wrapIdForCommon(config.id), 'dropdownContent')
    @Toolbar(wrapIdForTextTab(config.id), 'dropdownContent')
    public showContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.showContent(info, true);
    }

    @Toolbar(wrapIdForTextTab(config.id), 'shouldDisabled')
    public shouldDisabledTextEffect(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.shouldDisabledTextEffect();
    }
}
